import { render, staticRenderFns } from "./CameraComp.vue?vue&type=template&id=db3afeb6"
import script from "./CameraComp.vue?vue&type=script&lang=js"
export * from "./CameraComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports